import React, { useMemo } from 'react';
import useSearchMarkers from './hooks/useSearchMarkers';
import SearchMap from './SearchMap';
import config from './config/config';

const SearchMapData = () => {
	const { hits, source } = useSearchMarkers();

	const bounds = useMemo( () => {
		if ( ! hits || hits.length === 0 ) {
			return;
		}
		const coords = hits.map( ( hit ) => hit._geoloc ).filter( ( coord ) => coord );

		const lats = coords.map( ( coord ) => coord.lat );
		const lngs = coords.map( ( coord ) => coord.lng );
		// floorplans do not have coords, so could be no markers for map
		if ( lats.length === 0 || lngs.length === 0 ) {
			return config.MAP_DEFAULT_BOUNDS;
		}
		const maxLng = lngs.reduce( ( a, b ) => Math.max( a, b ) );
		const minLng = lngs.reduce( ( a, b ) => Math.min( a, b ) );
		const maxLat = lats.reduce( ( a, b ) => Math.max( a, b ) );
		const minLat = lats.reduce( ( a, b ) => Math.min( a, b ) );
		return {
			ne: {
				lat: maxLat,
				lng: maxLng,
			},
			sw: {
				lat: minLat,
				lng: minLng,
			},
		};
	}, [ hits ] );

	if ( ! hits || ! hits.length === 0 || ! bounds ) {
		return null;
	}

	return (
		<SearchMap hits={hits} source={source} bounds={bounds} />
	);
};

export default SearchMapData;
